import React, { useEffect, useState } from "react";
import { doc, getDoc } from "firebase/firestore";
import { db } from "./firebase";
import { useNavigate } from "react-router-dom";
import useUserData from "../hooks/useUserData";

const TeamDashboard = () => {
  const { userData, loading } = useUserData();
  const [teamData, setTeamData] = useState(null);
  const navigate = useNavigate();

    useEffect(() => {
        if (!loading) {
            if (!userData) {
                navigate("/starsonata"); 
            } else if (userData.teamId === "unassigned") {
                navigate("/join");
            } else if (!userData.verified) {
                navigate("/starsonata");
            }
        }
    }, [userData, loading, navigate]);

  useEffect(() => {
    const fetchTeamData = async () => {
      if (userData?.teamId) {
        const teamRef = doc(db, "teams", userData.teamId);
        const snap = await getDoc(teamRef);

        if (snap.exists()) {
          const team = snap.data();
          const updatedTeam = { ...team };

          // Fetch leader's username
          if (team.leaderUid) {
            const leaderRef = doc(db, "users", team.leaderUid);
            const leaderSnap = await getDoc(leaderRef);
            if (leaderSnap.exists()) {
              const leader = leaderSnap.data();
              updatedTeam.leaderName = leader.username || team.leaderUid;
            } else {
              updatedTeam.leaderName = team.leaderUid;
            }
          }

          setTeamData(updatedTeam);
        }
      }
    };

    fetchTeamData();
  }, [userData]);

  if (loading || !userData) return <p>Loading team info...</p>; 

  return (
    <div style={styles.container}>

      <h1 style={{color: "var(--theme-text-color)"}}>
        Welcome, {userData.username}!
        </h1>
      <h2 style={{color: "var(--theme-text-color)"}}>
       Team: <strong>{userData.teamName}</strong>
        </h2>
      {teamData?.leaderName ? (
        <p style={{color: "var(--theme-text-color)"}}>
          <strong>Team Leader:</strong> {teamData.leaderName}
          </p>
      ) : (
        <p style={{color: "var(--theme-text-color)"}}>Team Leader: None</p>
      )}
    </div>
  );
};

const styles = {
  container: {
    padding: "2rem",
    textAlign: "center",
    backgroundColor: "var(--theme-color)",
    borderRadius: "10px",
    maxWidth: "700px",
    margin: "3rem auto",
    boxShadow: "0 4px 15px rgba(0,0,0,0.9)",
  },
  logo: {
    maxWidth: "150px",
    marginBottom: "1rem",
  },
  navSection: {
    marginTop: "2rem",
    display: "flex",
    justifyContent: "center",
    flexWrap: "wrap",
    gap: "1rem",
  },
  button: {
    padding: "1rem 2rem",
    fontSize: "1rem",
    border: "none",
    borderRadius: "8px",
    backgroundColor: "#330055",
    color: "#fff",
    cursor: "pointer",
  },
};

export default TeamDashboard;
